import { Jurisdiction } from "@obg/ngx.core";
import { filter, isEmpty, some } from "lodash-es";

import { ContentUserState, JurisdictionState, UserStates } from "./content.model";

export function filterByContentState<T extends ContentUserState>(items: T[], isAuthenticated: boolean): T[] {
	const userState = isAuthenticated ? UserStates.LoggedIn : UserStates.LoggedOut;
	return filter(
		items,
		(item) => isEmpty(item.userState) || some(item.userState, (x) => x === UserStates.Anyone || x === userState)
	);
}

export function filterByJurisdictionState<T extends JurisdictionState>(
	items: T[],
	jurisdiction: Jurisdiction | undefined
): T[] {
	return filter(
		items,
		(item) => isEmpty(item.jurisdiction) || some(item.jurisdiction, (x) => x === jurisdiction || x === "any")
	);
}
